<template>
  <div class="repo-notice-list">
    <h2 class="repo-notice-list__title">回购通知书列表</h2>
    <div class="repo-notice-list__content">
      <el-form ref="form"
               class="repo-notice-list__search"
               :inline="true"
               :model="search"
               label-width="90px">
        <el-form-item label="项目编号">
          <el-input v-model="search.applyCode"></el-input>
        </el-form-item>
        <el-form-item label="通知书编号">
          <el-input v-model="search.noticeNo"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="search.applytitle"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="search.baseProductName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="买家名称">
          <el-input v-model="search.buyerName"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary"
                     class="search-btn"
                     @click="searchList">查询</el-button>
        </el-form-item>
      </el-form>

      <!--列表数据-->
      <el-table :data="repoNoticeList"
                style="width: 100%;overflow: hidde"
                align="center"
                class="repo-notice-list__table">
        <el-table-column label="序号"
                         width="70"
                         align="center"
                         type="index">
        </el-table-column>

        <el-table-column prop="noticeNo"
                         show-overflow-tooltip
                         label="通知书编号"
                         align="center"></el-table-column>
        <el-table-column prop="applyCode"
                         show-overflow-tooltip
                         label="项目编号"
                         align="center"></el-table-column>
        <el-table-column prop="applytitle"
                         show-overflow-tooltip
                         label="项目名称"
                         align="center"></el-table-column>
        <!-- <el-table-column prop="accountsReceivableAmount"
                         show-overflow-tooltip
                         label="应收账款金额"
                         width="180"
                         align="center">
          <template slot-scope="scope">{{scope.row.accountsReceivableAmount | addThousandSign(2)}}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="accountsReceivableEndTimeStr"
                         show-overflow-tooltip
                         label="到期日"
                         width="80"
                         align="center"></el-table-column> -->
        <!-- <el-table-column prop="disputeUnsolvedAmount"
                         show-overflow-tooltip
                         label="争议未解决金额"
                         width="100"
                         align="center">
          <template slot-scope="scope">{{scope.row.disputeUnsolvedAmount | addThousandSign(2)}}</template>
        </el-table-column>
        <el-table-column prop="disputeReturnPrincipal"
                         show-overflow-tooltip
                         label="应退还金额"
                         width="90"
                         align="center">
          <template slot-scope="scope">{{scope.row.disputeReturnPrincipal | addThousandSign(2)}}</template>
        </el-table-column> -->
        <el-table-column prop="confirmStatusStr"
                         show-overflow-tooltip
                         label="确认状态"
                         align="center"></el-table-column>
        <el-table-column prop="createtimeStr"
                         show-overflow-tooltip
                         label="创建时间"
                         align="center"></el-table-column>

        <el-table-column label="操作"
                         align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="primary"
                       @click="goToDetail(scope.row.noticeId)"
                       class="btn operation">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="repoNoticeList.length > 0"
                     class="repo-notice-list__pagination"
                     :page-size="pageSize"
                     :total="totalCount"
                     :current-page="currentPage"
                     @current-change="changePage"
                     layout="prev, pager, next"></el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../api/repoNotice.js';
export default {
  name: 'RepoNoticeList',
  data () {
    return {
      search: {
        applyCode: '',
        noticeNo: '',
        applytitle: '',
        baseProductName: '',
        buyerName: ''
      },
      repoNoticeList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0
    };
  },
  methods: {
    getData (search, pageNum = 1, pageSize = 10) {
      const that = this;
      api.getRepoNoticeList(search, pageNum, pageSize).then((resp) => {
        if (resp.data.rspcode == 1) {
          const respData = resp.data.data;
          that.currentPage = respData.currentPage;
          that.totalCount = respData.totalCount;
          that.repoNoticeList = respData.blLoanItemRepoNoticeList;
        }
      });
    },
    changePage (pageNum) {
      this.currentPage = pageNum;
      this.getData(this.search, this.currentPage);
    },
    searchList () {
      this.getData(this.search);
    },
    goToDetail (id) {
      this.$router.push(`/personalCenter/repoNotice/detail/${id}`);
    }
  },
  mounted () {
    this.getData();
  }
};
</script>


<style>
.repo-notice-list__title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}
.repo-notice-list__content {
  box-sizing: border-box;
  background-color: #fff;
  width: 970px;
  margin-left: 20px;
  padding: 30px 22px 50px 18px;
}
.repo-notice-list__table .btn {
  width: 42px;
  height: 21px;
  padding: 1px;
}

.repo-notice-list__pagination {
  text-align: center;
  margin-top: 20px;
}
.repo-notice-list__search {
  width: 910px;
}
.repo-notice-list__search input {
  width: 150px;
}
.repo-notice-list__search .search-btn {
  margin-left: 30px;
  width: 80px;
}
</style>




// WEBPACK FOOTER //
// RepoNoticeList.vue?7e683ef2